import * as React from "react";
import { styled } from "@mui/material/styles";
import Button, { ButtonProps } from "@mui/material/Button";
import Stack from "@mui/material/Stack";

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: "white",
  backgroundColor: "#1E56FF",
  width: "100%",
  borderRadius: "16px",
  padding: "21px 20px",
  fontFamily: "DM Sans, sans-serif",
  textTransform: "capitalize",
  zIndex: 10,
  "@media (max-width: 1000px)": {
    padding: "15px 12px",
  },
  "&.Mui-disabled": {
    backgroundColor: "#8D9AB2", // Custom background color for disabled state
    color: "white", // Custom text color for disabled state
  },
}));

export default function PrimaryButton({
  label,
  style,
  disabled,
  classname,
  type,
  onClick,
}: any) {
  return (
    <Stack spacing={2} direction="row" className={classname}>
      <ColorButton
        variant="contained"
        style={style}
        disabled={disabled}
        type={type}
        onClick={onClick}
      >
        {label}
      </ColorButton>
    </Stack>
  );
}
